export { default as MagnifyingGlassCircleSolidIcon } from './MagnifyingGlassCircleSolidIcon';
